import TenantOrganizationConfigurationContainer from '@src/components/tenant/organizationconfiguration/TenantOrganizationConfigurationContainer';
import React from 'react';

const AdminTenantOrganizationPage = () => <TenantOrganizationConfigurationContainer />;

export default AdminTenantOrganizationPage;
